export type Env = 'local' | 'stg' | 'prod';

export interface FontAttribs {
	as?: string;
	crossOrigin?: '' | 'anonymous' | 'use-credentials' | undefined;
	href: string;
	rel: string;
	type?: string;
}

export type Cookies = {
	myocdevice?: string;
	myocpersonalisation?: string;
	oddsFormat?: string;
	subdivisionCode?: string;
	token?: string;
	usState?: string;
};

export type Hreflang = {
	href: string;
	hreflang: string;
};

export const ODDS_FORMAT = {
	AMERICAN: 'american',
	DECIMAL: 'decimal',
	FRACTIONAL: 'fractional',
} as const;

export type OddsFormat = (typeof ODDS_FORMAT)[keyof typeof ODDS_FORMAT];
